import { render, staticRenderFns } from "./headertab.vue?vue&type=template&id=71780e80&scoped=true&"
import script from "./headertab.vue?vue&type=script&lang=js&"
export * from "./headertab.vue?vue&type=script&lang=js&"
import style0 from "./headertab.vue?vue&type=style&index=0&id=71780e80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71780e80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71780e80')) {
      api.createRecord('71780e80', component.options)
    } else {
      api.reload('71780e80', component.options)
    }
    module.hot.accept("./headertab.vue?vue&type=template&id=71780e80&scoped=true&", function () {
      api.rerender('71780e80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/physical/headertab.vue"
export default component.exports